import { render, staticRenderFns } from "./bet-component.vue?vue&type=template&id=2c6635ae&scoped=true&"
import script from "./bet-component.vue?vue&type=script&lang=js&"
export * from "./bet-component.vue?vue&type=script&lang=js&"
import style0 from "./bet-component.vue?vue&type=style&index=0&id=2c6635ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6635ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6635ae')) {
      api.createRecord('2c6635ae', component.options)
    } else {
      api.reload('2c6635ae', component.options)
    }
    module.hot.accept("./bet-component.vue?vue&type=template&id=2c6635ae&scoped=true&", function () {
      api.rerender('2c6635ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/bet-component.vue"
export default component.exports